import { useEffect, useRef, useState } from "react";
import { getData, getDocOnCondition } from "../Firebase/firestore";
import {db, storage} from '../firebase'

import sh from '../assets/search.png'

function View_Fabric({setCurrent, setEdit}) {

    const [fabric, setFabric] = useState()

    const [useFabric, setUseFabric] = useState()

    useEffect(()=>{
        setUseFabric(fabric)
    }, [fabric])

    const [fabricTypeFilter ,setFabricTypeFilter] = useState("")
    const [brandFilter, setBrandFilter] = useState("")
    const [brand, setBrands] = useState()
    const [brandDropdownOpen, setBrandDropdownOpen] = useState(false)
    const brandDropdownRef = useRef(null)
    const [widthOptions, setWidthOptions] = useState([])
    const [widthFilter, setWidthFilter] = useState("")
    const [widthDropdownOpen, setWidthDropdownOpen] = useState(false)
    const widthDropdownRef = useRef(null)
    const [fabricTypeDropdownOpen, setFabricTypeDropdownOpen] = useState(false)
    const fabricTypeDropdownRef = useRef(null)

    const [search, setSearch] = useState()


    useEffect(()=>{
        const collection = db.collection('Fabric').doc('Suits').collection('fabrics')
        getData(collection).then((data)=>{
            let arr = []
            // data.forEach((val)=>{   
            //     arr.push({...val, ...{"color":val["color"].join(" ,"), "material":val["material"].join(" ,")}})
            // })

            setFabric(data)

            const br = []
            data.forEach((val)=>{
                if(!br.includes(val.brand)){
                    br.push(val.brand)
                }
            })
            setBrands(br)
            const widths = []
            data.forEach((val)=>{
                if(val.width && !widths.includes(val.width)){
                    widths.push(val.width)
                }
            })
            setWidthOptions(widths)

            console.log(data)
        })

    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target)) {
                setBrandDropdownOpen(false);
            }
            if (widthDropdownRef.current && !widthDropdownRef.current.contains(event.target)) {
                setWidthDropdownOpen(false);
            }
            if (fabricTypeDropdownRef.current && !fabricTypeDropdownRef.current.contains(event.target)) {
                setFabricTypeDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filterResults = ()=>{

        if(!fabric){
            return;
        }
        let filtered = [...fabric];

        if(search){
            const terms = String(search).toLowerCase().split(" ").filter(Boolean);
            filtered = filtered.filter((val)=> terms.every((term)=>JSON.stringify(val).toLowerCase().includes(term)));
        }

        if(fabricTypeFilter){
            filtered = filtered.filter((val)=> (val.fabricType || "").toLowerCase() === fabricTypeFilter.toLowerCase());
        }

        if(brandFilter){
            filtered = filtered.filter((val)=> (val.brand || "").toLowerCase() === brandFilter.toLowerCase());
        }

        if(widthFilter){
            filtered = filtered.filter((val)=> (val.width || "").toLowerCase() === widthFilter.toLowerCase());
        }

        setUseFabric(filtered)
    }

    useEffect(()=>{
        filterResults()
    }, [fabricTypeFilter, brandFilter, widthFilter, fabric])

    return ( 
    
    <div className="edit-fabric-page">

        <div className="edit-fabric-filterbar">
            <div className="edit-fabric-filter-item" ref={brandDropdownRef}>
                <div className="fabric-custom-select">
                    <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setBrandDropdownOpen((v) => !v)}>
                        <span>{brandFilter || "All Brands"}</span>
                        <span className={`fabric-custom-select-arrow ${brandDropdownOpen ? "open" : ""}`}>▾</span>
                    </button>
                    {brandDropdownOpen && (
                        <div className="fabric-custom-select-menu edit-fabric-select-menu">
                            <button type="button" className={`fabric-custom-select-option ${brandFilter === "" ? "active" : ""}`} onClick={() => { setBrandFilter(""); setBrandDropdownOpen(false); }}>All Brands</button>
                            {brand && brand.map((val)=>(
                                <button type="button" key={val} className={`fabric-custom-select-option ${brandFilter === val ? "active" : ""}`} onClick={() => { setBrandFilter(val); setBrandDropdownOpen(false); }}>{val}</button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="edit-fabric-filter-item" ref={fabricTypeDropdownRef}>
                <div className="fabric-custom-select">
                    <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setFabricTypeDropdownOpen((v) => !v)}>
                        <span>{fabricTypeFilter === "Shirt" ? "Shirting" : fabricTypeFilter || "All Types"}</span>
                        <span className={`fabric-custom-select-arrow ${fabricTypeDropdownOpen ? "open" : ""}`}>▾</span>
                    </button>
                    {fabricTypeDropdownOpen && (
                        <div className="fabric-custom-select-menu edit-fabric-select-menu">
                            <button type="button" className={`fabric-custom-select-option ${fabricTypeFilter === "" ? "active" : ""}`} onClick={() => { setFabricTypeFilter(""); setFabricTypeDropdownOpen(false); }}>All Types</button>
                            <button type="button" className={`fabric-custom-select-option ${fabricTypeFilter === "Suiting" ? "active" : ""}`} onClick={() => { setFabricTypeFilter("Suiting"); setFabricTypeDropdownOpen(false); }}>Suiting</button>
                            <button type="button" className={`fabric-custom-select-option ${fabricTypeFilter === "Shirt" ? "active" : ""}`} onClick={() => { setFabricTypeFilter("Shirt"); setFabricTypeDropdownOpen(false); }}>Shirting</button>
                        </div>
                    )}
                </div>
            </div>

            <div className="edit-fabric-filter-item" ref={widthDropdownRef}>
                <div className="fabric-custom-select">
                    <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setWidthDropdownOpen((v) => !v)}>
                        <span>{widthFilter || "All Widths"}</span>
                        <span className={`fabric-custom-select-arrow ${widthDropdownOpen ? "open" : ""}`}>▾</span>
                    </button>
                    {widthDropdownOpen && (
                        <div className="fabric-custom-select-menu edit-fabric-select-menu">
                            <button type="button" className={`fabric-custom-select-option ${widthFilter === "" ? "active" : ""}`} onClick={() => { setWidthFilter(""); setWidthDropdownOpen(false); }}>All Widths</button>
                            {widthOptions.map((val)=>(
                                <button type="button" key={val} className={`fabric-custom-select-option ${widthFilter === val ? "active" : ""}`} onClick={() => { setWidthFilter(val); setWidthDropdownOpen(false); }}>{val}</button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="edit-fabric-search">
                <div className="edit-fabric-search-box">
                    <input className="search_fabric_clothes" 
                        placeholder="Search"
                        value={search || ""}
                        onChange={(e)=>{
                            setSearch(e.target.value)
                        }}
                    />
                    <img src={sh}
                        onClick={()=>{filterResults()}}
                    />
                </div>
            </div>
        </div>


        <div className="edit-fabric-results">
        {useFabric && useFabric.map((value, key)=>{
            return(
                <div className="edit-fabric-card">
                    <img src={value.src} className="edit-fabric-card-image"/>
                    <div className="edit-fabric-card-details">
                        <div style={{"width":"fitContent"}}>
                           <b>Name : {value.name} </b>
                        </div>
                        <div>
                        <b> Colour : {value.color} </b>
                        </div>
                        <div>
                        <b> Brand : {value.brand} </b>
                        </div>
                    </div>
                    <div>
                        <button
                            className="edit-fabric-card-btn"
                            onClick={()=>{
                                setEdit({...value, ...{"type":1}})
                                setCurrent(2)
                            }}
                        ><span className="edit-fabric-card-btn-icon">✎</span> Edit</button>
                        {/* <button
                            onClick={async()=>{
                                console.log("coming here")
                                const collection = db.collection('Fabric').doc('Suits').collection('fabrics')
                                const ID = (await getDocOnCondition(collection, "src", value["src"]))[0]
                                console.log("ID:", ID)
                                const DOC = await collection.doc(ID).delete()
                                window.location.reload();
                            }}
                        >Delete</button> */}
                    </div>
                    
                </div>
            )
        })

        }
        </div>
        

    </div> 
);
}

export default View_Fabric;